import type { CmsThemeTokens } from "./renderProps";

// Claro Advisors brand foundation. Mirrors the palette and Adobe Typekit
// families (ivypresto-display + halyard-text, kit emr7xgx) used on
// claroadvisors.com so published microsites match the brand exactly.
export const defaultCmsTheme: CmsThemeTokens = {
  colorBackground: "#f8f7f5", // claro linen
  colorSurface: "#ffffff",
  colorText: "#2c2424", // claro cocoa
  colorMutedText: "#5c5252", // cocoa-70
  colorAccent: "#69c8cf", // claro aqua
  colorAccentText: "#2c2424", // cocoa reads on aqua
  colorBorder: "#efece7", // linen-shade
  fontFamily: '"halyard-text", "Source Sans 3", "Source Sans Pro", system-ui, -apple-system, sans-serif',
  maxWidth: "1200px",
};

export function themeStyle(theme: CmsThemeTokens = defaultCmsTheme): Record<string, string> {
  return {
    "--cms-color-background": theme.colorBackground,
    "--cms-color-surface": theme.colorSurface,
    "--cms-color-text": theme.colorText,
    "--cms-color-muted-text": theme.colorMutedText,
    "--cms-color-accent": theme.colorAccent,
    "--cms-color-accent-text": theme.colorAccentText,
    "--cms-color-border": theme.colorBorder,
    "--cms-font-family": theme.fontFamily,
    "--cms-max-width": theme.maxWidth,
  };
}
